import { css } from '@emotion/core'
import { smallOnly, mediumUp } from 'Utils'
import theme from 'Theme'
const { mixins } = theme

export default () => css`
  .heading {
    height: 50px;
    div {
      position: relative;
      top: 5px;
      height: 40px;
      width: auto;
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
      ${mixins.loadingLight(theme)}
    }
  }

  .panel-trigger {
    height: 32px;
    div {
      position: relative;
      top: 5px;
      height: 32px;
      width: 300px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .product-card-load,
  .product-list-loading {
    ${mixins.loadingLight(theme)}
    height: 400px;
    @media ${mediumUp} {
      height: 500px;
    }
  }

  .categories-load {
    @media ${mediumUp} {
      display: none;
    }
    @media ${smallOnly} {
      margin-top: 20px;
      margin-bottom: 20px;
      div {
        height: 38px;
        ${mixins.loadingLight(theme)}
      }
    }
  }
`
